import type { AccessControl } from '@schibsted/frapi-schema';

const subscriberOnly = (access: AccessControl): boolean =>
  access && access.restrictions && access.restrictions.includes('closed');

const metered = (access: AccessControl): boolean =>
  access && access.restrictions && access.restrictions.includes('automatic');

export const accessLevel = (
  access: AccessControl,
): 'Paid' | 'Meter' | 'Free' =>
  metered(access) ? 'Meter' : subscriberOnly(access) ? 'Paid' : 'Free';

export const accessLevelName = (access: AccessControl): string =>
  accessLevel(access);
